
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"inWorkbookStorage":"(Arbeitsmappen-intern)","openInManagementCenter":"Attribut im Management Center öffnen"},"en":{"inWorkbookStorage":"(workbook internal)","openInManagementCenter":"Open attribute in Management Center"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();